import { Checkbox } from "@frends/ui-components/react";

export default Checkbox;
